
<svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_16571_26332)">
    <path
      d="M9.32812 15.2036C9.66142 15.3121 10.3947 15.5145 10.6613 15.4566C10.9946 15.3844 12.5777 14.4807 12.8694 14.4084C13.161 14.3361 13.6609 14.1915 14.0776 14.4084C14.4942 14.6253 14.8275 15.4566 14.5358 15.7097C14.2442 15.9627 11.5779 17.3002 11.3279 17.3363C11.1279 17.3652 10.0503 17.2038 9.53643 17.1194"
      :stroke="color"
      stroke-width="1.5"
    />
    <path
      d="M26 12L28.1909 12.9091C28.352 13 28.7128 13.2727 28.8675 13.6364C29.0608 14.0909 29.1574 15.6364 28.3197 15.8182C27.772 16 28.0298 16 27.5465 16C27.1599 16 26.3974 15.6061 26.0644 15.4091"
      :stroke="color"
      stroke-width="1.5"
    />
    <path
      d="M4.3732 22.9393L1.04026 29.6628C0.873756 30.0604 1.24862 30.6387 1.70665 30.8195C2.04021 30.9511 2.62347 31.0725 3.16486 30.6387C3.73859 30.1791 5.37293 26.4215 6.1645 24.6383"
      :stroke="color"
      stroke-width="1.5"
    />
    <path
      d="M18.6441 19.4327L13.8046 29.1512C13.5628 29.726 14.1071 30.562 14.7722 30.8232C15.2565 31.0135 16.1034 31.189 16.8896 30.562C17.7227 29.8975 20.0958 24.4662 21.2452 21.8885"
      :stroke="color"
      stroke-width="2"
    />
    <path
      d="M6.24407 16.7582L4.74425 17.6165M4.74425 17.6165L4.28597 17.8788L3.4944 20.1561C3.20846 20.9875 1.37631 20.8429 1.57796 19.7946C1.87793 18.262 2.25844 17.2763 2.4112 16.9751L5.57749 14.9147C5.86912 14.746 6.69402 14.5098 7.66057 14.9147C8.12718 15.175 8.41048 15.6497 8.4938 15.8545V22.2526L11.8267 25.1444L12.9516 29.6267C13.2849 30.7473 10.9226 31.904 10.4519 29.7713C10.1519 28.4122 9.7992 27.0362 9.66033 26.518L5.49416 23.4094C5.25808 23.1684 4.77758 22.5997 4.74425 22.2526C4.71092 21.9056 4.73036 19.0173 4.74425 17.6165Z"
      :stroke="color"
      stroke-width="1.5"
    />
    <path
      d="M21.3007 10.5516L19.1422 11.787M19.1422 11.787L18.4827 12.1645L17.3435 15.4423C16.9564 16.5048 14.2372 16.6856 14.5854 14.9221C15.0171 12.716 15.5647 11.2974 15.7846 10.8638L20.3414 7.89817C20.7611 7.65537 21.9482 7.31544 23.3393 7.89817C24.0108 8.27277 24.4185 8.95609 24.5384 9.25092V18.46L29.3351 22.6223L30.9539 29.0739C31.4336 30.6868 28.0338 32.3517 27.3564 29.282C26.9247 27.3257 26.4171 25.3452 26.2172 24.5994L20.2214 20.1249C19.8817 19.7781 19.1902 18.9595 19.1422 18.46C19.0942 17.9605 19.1222 13.8033 19.1422 11.787Z"
      :stroke="color"
      stroke-width="2"
    />
    <path
      d="M9.25 10.6563C9.25 11.8249 8.26526 12.8125 7 12.8125C5.73474 12.8125 4.75 11.8249 4.75 10.6563C4.75 9.48766 5.73474 8.5 7 8.5C8.26526 8.5 9.25 9.48766 9.25 10.6563Z"
      :stroke="color"
      stroke-width="1.5"
    />
    <path
      d="M24.9922 3.39064C24.9922 4.82676 23.7836 6.03127 22.2422 6.03127C20.7008 6.03127 19.4922 4.82676 19.4922 3.39064C19.4922 1.95452 20.7008 0.75 22.2422 0.75C23.7836 0.75 24.9922 1.95452 24.9922 3.39064Z"
      :stroke="color"
      stroke-width="1.5"
    />
  </g>
  <defs>
    <clipPath id="clip0_16571_26332">
      <rect width="32" height="32" fill="white" />
    </clipPath>
  </defs>
</svg>
